import prodTestThumbSandboxStylesText from './prod-test-thumb-sandbox.styles.css?inline';
import { unsafeCSS } from 'lit';
import { fillHeightHostStyles } from '../../../styles/fill-height-table.styles';

export const prodTestThumbSandboxStyles = [
  fillHeightHostStyles,
  unsafeCSS(prodTestThumbSandboxStylesText),
];
